<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <!-- panneau gauche -->
  <wiz-vgroup width="300px" minWidth="0px" maxWidth="300px" height="100%">
    <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
      <wiz-hgroup target="header-title" width="100%">
        <wiz-label [wizLabel]="'$.vision.target.title.$'" class="titleLabel" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-vgroup>

  <!-- zone détail -->
  <wiz-group width="100%" height="100%" class="section-container-parent">
    <!-- lorsque rien n'est sélectionné -->
    <widget-renderer
      *ngIf="!isDetailVisible()"
      class="view-widget"
      width="100%"
      [title]="'$.vision.home.title.$'"
      [description]="'$.vision.home.description.$'"></widget-renderer>

    <!-- zone détail -->
    <wiz-vgroup #vgDetailZone [visible]="isDetailVisible()" width="100%" height="100%" style="overflow: auto;">

    <wiz-hgroup height="300px" width="100%" style="padding: 0 5px 5px 0;"> <!-- zone state et lines. Padding pour garder le shadow et ne pas être collé à la scrollBar -->


      <wiz-vgroup width="450px" height="100%" class="section-container"> <!-- zone lines -->
        <wiz-hgroup width="100%" verticalAlign="center">
          <wiz-label class="titleLabel" width="100%" [wizLabel]="'$.vision.generate.lines.$'"></wiz-label>
          <wiz-icon [wizTooltip]="'$.export.baselines.$'" tooltipPlacement="left" class="image-purple" (click)="doAct('export')">download</wiz-icon>
          <wiz-icon [wizTooltip]="'$.import.baselines.$'" tooltipPlacement="left" class="image-purple" (click)="doAct('import')" >upload</wiz-icon>
        </wiz-hgroup>     
        
        <wiz-hgroup width="100%" height="100%">
            <wiz-vgroup gap="20" width="220px" height="100%">
              <wiz-button #btnGenerate width="200px" [wizIcon]="'validate'" [wizLabel]="'$.visionstep.generate.$'" (wizClick)="doAction($event)" [wizDisabled]="visionLocked()"></wiz-button>
              <wiz-button #btnGenerateDelta width="200px" [wizIcon]="'validate'" [wizLabel]="'$.visionstep.generate.delta.$'" (wizClick)="doAction($event)" [wizDisabled]="visionLocked()"></wiz-button>
              <wiz-button #btnDelete width="200px" [wizIcon]="'delete'" [wizLabel]="'$.visionstep.delete.$'" (wizClick)="doAction($event)" [wizDisabled]="visionLocked()"></wiz-button>     
            </wiz-vgroup>
            <wiz-vgroup gap="20" width="220px" height="100%">
              <wiz-button #btnReset width="200px" [wizIcon]="'reset'" [wizLabel]="'$.visionstep.reset.$'" (wizClick)="doAction($event)" [wizDisabled]="visionLocked()"></wiz-button>
              <wiz-button #btnclearCache width="200px" [wizIcon]="'delete'" [wizLabel]="'$.common.clear.cache.$'" (wizClick)="doAction($event)" [wizDisabled]="visionLocked()"></wiz-button>
              <wiz-button #btnSample wizDisabled="true" width="200px" [wizIcon]="'reset'" [wizLabel]="'$.visionstep.sample.$'" (wizClick)="doAction($event)"></wiz-button>
            </wiz-vgroup>
        </wiz-hgroup>
      </wiz-vgroup> 

      <wiz-vgroup wi width="100%" height="100%" class="section-container">
        <multi-display code="visionStepMD" #gdSteps width="100%" height="100%" [config]="stepConfig">
          <wiz-hgroup target="header-title" width="100%">     
              <wiz-image #uploadImg height="40px" width="40px"></wiz-image>
              <wiz-label #lblTitle class="titleLabel"></wiz-label>
          </wiz-hgroup>
        </multi-display>
      </wiz-vgroup>

    </wiz-hgroup> <!-- fin zonelines -->


    <wiz-vgroup height="100%" width="100%"> <!-- zone périmètres-->
   
      <wiz-hgroup height="100%" width="100%" style="padding: 0 5px 5px 0;">

        <wiz-vgroup width="450px" height="100%" class="section-container"> <!-- grid vsp & keys-->
          <wiz-label class="titleLabel" [wizLabel]="'$.vision.generate.perimeters.$'"></wiz-label>
          <multi-display code="visionPerimeterMD" #gdPerimeters width="100%" height="100%" [config]="perimetersConfig">  <!-- choix du vsp -->
            
            <wiz-hgroup verticalAlign="center" target="header-title" style="padding: 5px" width="100%">
              <wiz-icon #btnCreateVsp [wizTooltip]="'$.vsp.create.$'" tooltipPlacement="right" class="image-back-orange" (click)="doAct('createVSP')">add</wiz-icon>
              <wiz-label [wizLabel]="'$.vsp.create.$'" class="smallTitleLabel" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
              <wiz-icon #btnRemove [visible]="!!currentPerimeter" class="image-purple" [wizTooltip]="'$.common.delete.$'" (click)="doAct('deleteVSP')" >delete</wiz-icon>
            </wiz-hgroup>
          </multi-display>
        </wiz-vgroup>

        <wiz-vgroup #vgEdition [visible]="hasPerimeter()" wizValidationContainer width="100%" height="100%" class="section-container" style="padding: 5px"> <!-- détail du vsp-->
          <!-- header du vsp -->
          <wiz-hgroup #hgCodeLabel gap="20">
              <wiz-vgroup width="160px">
                <wiz-dropdown #ddStep width="100%" [wizMandatory]="true" 
                [wizLabel]="'$.step.choose.$'" [wizDataProvider]="stepChooserDS" [wizDisabled]="stepExist"
                [wizLabelField]="'levelAndLabel'"></wiz-dropdown>
                <wiz-translation-basic
                #trsLabel
                wizValidator
                [wizPlaceholder]="'$.common.define.$'"
                [wizLabel]="'$.common.label.$'"
                width="160px"
                [wizShowErrors]="true"
                [wizMandatory]="true"></wiz-translation-basic>
              </wiz-vgroup>
              <wiz-text-input #tiCode [wizDisabled]="clonePerimeter?.exist" width="100%" class="upper-case-input" [wizPlaceholder]="'$.common.define.$'" [wizLabel]="'$.vsp.code.$'" [wizShowErrors]="true" [wizMandatory]="true" [wizMaxChars]="50"></wiz-text-input>
              <wiz-translation-basic
                #trsDesc
                [wizTranslationMode]="'textarea'"
                [maxTranslation]="6"
                [wizLabel]="'$.common.description.$'"
                [wizPlaceholder]="'$.common.define.$'"
                width="250px"
                height="108px"></wiz-translation-basic>
              <wiz-spacer width="100%"></wiz-spacer>
              <!-- boutons d'action vsp -->
              <wiz-vgroup width="200px" height="100%" horizontalAlign="center" verticalAlign="end">
                <wiz-button #btnSaveStep [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'" [iconPlacement]="'right'" [wizDisabled]="disableVspSave()"></wiz-button>
                <wiz-button #btnCancelStep class="cancel-button" [wizIcon]="'arrow-left'" [wizLabel]="'$.common.cancel.modification.$'" [wizDisabled]="disableVspCancel()"></wiz-button>
              </wiz-vgroup>
            </wiz-hgroup>
          <!-- pivotComponent de construction des clés  -->
          <wiz-hgroup width="100%"  height="100%" [visible]="showGrid">
            <tool-pivot-component
            #vspKeyMatrix
            width="100%"
            height="100%"
            [model]="model"
            [uid]="'vspPivot'"
            [pivotMode]="true"
            [templatingMode]="true"
            rowSelection="'multiple"
          ></tool-pivot-component>
          </wiz-hgroup>
        </wiz-vgroup>


      </wiz-hgroup>
    </wiz-vgroup>

    </wiz-vgroup>

  </wiz-group>
</wiz-h-divider>
